export const DATE_FILTER_LOADING = 'DATE_FILTER_LOADING';
export const DATE_FILTER_LOAD_ERROR = 'DATE_FILTER_LOAD_ERROR';
export const DATE_FILTER_RECEIVED = 'DATE_FILTER_RECEIVED';

export const UPDATE_CLUSTERS_STATE = "UPDATE_CLUSTERS_STATE";
export const UPDATE_QUERY_STATE = "UPDATE_QUERY_STATE";

export const CLUSTER_DATA_LOADING = "CLUSTER_DATA_LOADING";
export const CLUSTER_DATA_LOAD_ERROR = "CLUSTER_DATA_LOAD_ERROR";
export const CLUSTER_DATA_RECEIVED = "CLUSTER_DATA_RECEIVED";

export const TABLE_DATA_LOADING = "TABLE_DATA_LOADING";
export const TABLE_DATA_LOAD_ERROR = "TABLE_DATA_LOAD_ERROR";
export const TABLE_DATA_RECEIVED = "TABLE_DATA_RECEIVED";

export const UTTERANCES_DATA_LOADING = "UTTERANCES_DATA_LOADING";
export const UTTERANCES_DATA_LOAD_ERROR = "UTTERANCES_DATA_LOAD_ERROR";
export const UTTERANCES_DATA_RECEIVED = "UTTERANCES_DATA_RECEIVED";
export const MORE_UTTERANCES_RECEIVED = "MORE_UTTERANCES_RECEIVED";


// WEBPACK FOOTER //
// ./src/data/redux/query_details/actiontypes.js